<template>
  <div
      class="tooltip-drop-shadow relative flex flex-col w-[348px] h-fit bg-grays-200 rounded-md px-6 py-4"
  >
    <div
        class="custom-scroll-bar w-full h-[148px] flex flex-col overflow-y-scroll pl-[12px] border-b border-grays-400 text-right"
    >
      <div v-for="item in items" :key="item.id">
        <div
            class="item flex flex-row-reverse border-b border-grays-400 py-2 items-center"
        >
          <div class="flex flex-col items-end w-fit">
            <p class="font-bold text-sm text-primary-900">
              {{ item?.item_sale?.price }} ₪
            </p>
          </div>
          <div class="flex flex-1 flex-col gap-1">
            <p class="text-primary-700 font-bold text-sm">
              {{ item?.item_sale?.product?.name }}
            </p>
            <!-- <p class="text-grays-900 font-medium text-xs">
              {{ item.item_sale.price }} ₪
              <span class="text-grays-700 text-xs">(3.85 לק”ג)</span>
            </p> -->
          </div>
          <img
              :src="
              'https://images.mishnatyosef.org/images/items/' +
              item?.item_sale?.product?.featured_image
            "
              alt="item"
              class="h-[49px] rounded-[5px] ml-[8px]"
          />
        </div>
      </div>
    </div>
    <div class="flex flex-row mt-[8px]">
      <span class="material-symbols-rounded text-error text-base">error</span>
      <p class="text-sm mr-[7px] text-error font-medium">
        המוצרים הנ”ל לא חויבו
      </p>
    </div>
    <img
        alt="polygon green"
        class="absolute w-[19px] h-[11px] bottom-[-9px] left-[39px] m-auto"
        src="@/assets/icons/global/polygon-white.svg"
    />
  </div>
</template>

<script>
export default {
  name: "tooltip-missing-product",
  props: {
    items: Array,
  },
};
</script>

<style scoped>
.tooltip-drop-shadow {
  -webkit-filter: drop-shadow(1px 1px 8px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(1px 1px 8px rgba(0, 0, 0, 0.3));
}
</style>